/* eslint-disable */
/* tslint:disable */
import PropTypes from 'prop-types';
import React from 'react';
export const SadFaceSmallIcon = ({size, ...props}) => (
  <svg viewBox="0 0 14 14" fill="currentColor" width={ size || "14" } height={ size || "14" } {...props}>
    <path d="M13 19c-3.866 0-7-3.134-7-7s3.134-7 7-7 7 3.134 7 7-3.134 7-7 7zm0-1c3.314 0 6-2.686 6-6s-2.686-6-6-6-6 2.686-6 6 2.686 6 6 6zm2.885-2.28c-.359-1.255-1.515-2.174-2.885-2.174-1.374 0-2.532.924-2.888 2.185.478.135 0 0 .964.268.238-.838 1.01-1.453 1.924-1.453.915 0 1.687.615 1.924 1.454.337-.1 0-.001.96-.28zM11 10c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zm4 0c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1z"
      transform="translate(-6 -5)" fillRule="evenodd" />
  </svg>
);
SadFaceSmallIcon.displayName = 'SadFaceSmallIcon';
SadFaceSmallIcon.propTypes = {
  size: PropTypes.string
}
/* tslint:enable */
/* eslint-enable */
